import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  Dialog,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import SearchIcon from "@mui/icons-material/Search";
import AddBatch from "../AddBatch/AddBatch";
import AutoAddBatch from "../AddBatch/AutoAddBatch";
import MqttData from "../MqttData";
import { abortBatchDataAPI, getAutoBatchHistory } from "./Services";
import dayjs from "dayjs";
import { ToastContainer } from "react-toastify";
import { TablePagination } from "@mui/material";

const AbortBatchData = ({
  dialogContent,
  openM,
  setOpen,
  setDialogContent,
  handleClickOpen,
}) => {
  const [abortBatchData, setAbortBatchData] = useState([]);
  const [abortedBatchId, setAbortedBatchId] = useState(null);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const initiallValue = {
    Date: "",
    Time: "",
    Shift: "",
    Batch_No: "",
  };
  const [searchText, setSearchText] = useState(initiallValue);

  const handleSearchData = async (e) => {
    const { name, value } = e.target;

    setSearchText({ ...searchText, [name]: value });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    handleAutoBatchHistory();
  }, [searchText,page,rowsPerPage]);

  const handleAutoBatchHistory = async () => {
    const params ={
      search :searchText,
      page:page,
      rowsPerPage:rowsPerPage
    }
    
    try {
      const resp = await getAutoBatchHistory(params);
      if (resp.status == 200 || resp.status == 201) {
        setAbortBatchData(resp.data.payload);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleAbortBatch = async (batchId) => {
    const params = {
      batch_id: [batchId],
    };
    try {
      const resp = await abortBatchDataAPI(params);
      if (resp.status == 200 || resp.status == 201) {
        setAbortedBatchId(batchId);
        handleAutoBatchHistory();
      }
    } catch (error) {
      console.log("handleAbortBatch", error);
    }
  };
  return (
    <>
      <div className="page-wraper">
        <ToastContainer />
        <div className="page-header">
          <Link
            to="/dipping-parameters"
            className="page-back-btn"
            //   onClick={handleBack}
          >
            <ArrowBackIcon />
            <span style={{ width: "max-content" }}>Auto Batch Request</span>
          </Link>
        </div>
        <div className="table-responsive">
          <Table aria-label="Dipping parameter" className="dipping-params">
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Time</TableCell>
                <TableCell>Shift</TableCell>
                <TableCell>Batch No.</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Date"
                    name="Date"
                      value={searchText.Date}
                      onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Time"
                    name="Time"
                      value={searchText.Time}
                      onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Shift"
                    name="Shift"
                      value={searchText.Shift}
                      onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Batch No"
                    name="Batch_No"
                      value={searchText.Batch_No}
                      onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Action"
                    name="Lot_No"
                    //   value={searchText.Lot_No}
                    //   onChange={handleSearchData}
                  />
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {abortBatchData?.results?.map((data, index) => {
                const isAborted = data.is_abort;

                return (
                  <TableRow key={data.batch_id}>
                    <TableCell style={{ color: isAborted ? "red" : "inherit" }}>
                      {data?.created_at
                        ? dayjs(data?.created_at).format("DD/MM/YYYY")
                        : "-"}
                    </TableCell>
                    <TableCell style={{ color: isAborted ? "red" : "inherit" }}>
                      {data?.created_at
                        ? dayjs(data?.created_at).format("hh:mm:ss")
                        : "-"}
                    </TableCell>
                    <TableCell style={{ color: isAborted ? "red" : "inherit" }}>
                      {data?.shift_name}
                    </TableCell>
                    <TableCell style={{ color: isAborted ? "red" : "inherit" }}>
                      {data?.batch_type}
                    </TableCell>
                    <TableCell className="btn-column">
                      <button
                        className="start-button"
                        style={{background: isAborted ? "#d3d3d3" : "#f4f7fe"}}
                        onClick={() => handleClickOpen("batchRequest", data)}
                        disabled={isAborted} 
                      >
                        ADD
                      </button>
                      <button
                        className="start-button"
                        onClick={() => handleAbortBatch(data.batch_id)}
                      >
                        ABORT
                      </button>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          <TablePagination
              className="table-pagination"
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={abortBatchData ? abortBatchData.count : null}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </div>
      </div>
    </>
  );
};

export default AbortBatchData;